import { useSyncExternalStore } from 'react';

import { readProfile, subscribeToSession, type SessionProfile } from './session';

/**
 * Reads the in-memory session. There is no persisted copy to read from, and
 * nothing here is an authorization answer: the backend re-checks every call.
 */
export function useSessionProfile(): SessionProfile | null {
  return useSyncExternalStore(subscribeToSession, readProfile, () => null);
}
